export default __webpack_public_path__ + "static/media/CAMBRIAI.28f9969a.TTF";